import LedgerForm from '@/components/forms/master/account/ledger/LedgerForm';
import ItemForm from '@/components/forms/master/inventory/item/ItemForm';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import { List, Typography } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const ShortCutSettings = ({ onClose }) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState(null); // To manage modal type

  const handleShortcutClick = (shortcut) => {
    if (shortcut.route) {
      navigate(shortcut.route);
      onClose();
    } else if (shortcut.modal) {
      setModalType(shortcut.modal); // Set modal type
      setIsModalVisible(true); // Show modal
    }
  };

  // Define the shortcut categories and their respective keys
  const navigationData = [
    {
      category: 'Navigation',
      shortcuts: [
        {
          key: 'Alt + N',
          description: 'Create New Sales Page',
          route: '/sales/create',
        },
        {
          key: 'Alt + M',
          description: 'Sales Bill List',
          route: '/sales/list',
        },
        {
          key: 'Alt + P',
          description: 'Create New Purchase',
          route: '/purchase/create',
        },
        {
          key: 'Alt + R',
          description: 'Create New Receipt',
          route: 'receipt/voucher/create/',
        },
        {
          key: 'Alt + P',
          description: 'Create New Payment',
          route: '/payment/voucher/create/',
        },
        {
          key: 'Alt + J',
          description: 'Create New Journal',
          route: '/journal/voucher/list/',
        },
        { key: 'Alt + D', description: 'Dashboard', route: '/dashboard' },
        { key: 'Alt + L', description: 'Ledger List', route: '/ledger/list' },
        {
          key: 'Alt + I',
          description: 'Inventory Item List',
          route: '/inventory/item/list',
        },
        { key: 'Alt + r', description: 'Reports', route: '/reports' },
      ],
    },
    {
      category: 'Modal',
      shortcuts: [
        { key: 'Alt + l', description: 'Create New Ledger', modal: 'ledger' },
        { key: 'Alt + i', description: 'Create New Item', modal: 'item' },
      ],
    },
  ];
  const shortcutData = [
    {
      category: 'Common Keys',
      shortcuts: [
        { key: 'Ctrl + C', description: 'Copy' },
        { key: 'Ctrl + V', description: 'Paste' },
        { key: 'Ctrl + Z', description: 'Undo' },
      ],
    },
  ];

  return (
    <>
      <GlobalDivider name="Keyboard Shortcuts" orientation="center" />
      {/* Render each category and its respective shortcuts */}

      <div>
        {/* Render each category and its respective shortcuts */}
        {navigationData.map((category) => (
          <div key={category.category} style={{ marginBottom: '20px' }}>
            <List
              bordered
              header={
                <Title className="list-title" color="#189766c2" level={5}>
                  {category.category}
                </Title>
              }
              dataSource={category.shortcuts}
              renderItem={(item) => (
                <List.Item
                  className="drawer-list-item"
                  style={{ cursor: 'pointer', color: '#1890ff' }}
                  onClick={() => handleShortcutClick(item)}
                >
                  <strong className="list-subtitle">{item.key}</strong>
                  {''} -{' '}
                  <span style={{ color: 'black', fontWeight: 500 }}>
                    {item.description}
                  </span>
                </List.Item>
              )}
            />
          </div>
        ))}
      </div>
      <div>
        {shortcutData.map((category) => (
          <div key={category.category} style={{ marginBottom: '20px' }}>
            <List
              bordered
              header={
                <Title className="list-title" level={5}>
                  {category.category}
                </Title>
              }
              dataSource={category.shortcuts}
              renderItem={(item) => (
                <List.Item className="drawer-list-item">
                  <strong className="list-subtitle">{item.key}</strong>
                  {''} -{' '}
                  <span
                    style={{
                      color: 'black',
                      fontWeight:500
                    }}
                  >
                    {item.description}
                  </span>
                </List.Item>
              )}
            />
          </div>
        ))}
      </div>
      <GlobalFormModal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        {modalType === 'ledger' ? (
          <LedgerForm onClose={() => setIsModalVisible(false)} />
        ) : (
          <ItemForm onClose={() => setIsModalVisible(false)} />
        )}
      </GlobalFormModal>
    </>
  );
};

export default ShortCutSettings;
